// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".note[data-v-4d623a9e]{width:100%;max-width:750px;box-sizing:border-box;padding:clamp(1rem,.852rem + .741vw,1.5rem)}.note__titre[data-v-4d623a9e]{margin-bottom:8px;display:flex}.note__texte[data-v-4d623a9e]{margin:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
